<template>
	<div class="">
		<b-row class="mb-2">
			<!-- Date picker -->
			<b-col cols="12" md="7">
				<b-row>
					<b-col md="5  ">
						<label for="example-input">From Date</label>
						<b-form-datepicker
							id="from-date"
							placeholder="Choose a date"
							local="en"
							v-model="search_filter.from_date"
						/>
					</b-col>
					<b-col md="5 p-0">
						<label for="example-input">To Date</label>
						<b-form-datepicker id="to-date" placeholder="Choose a date" local="en" v-model="search_filter.to_date" />
					</b-col>
					<b-col md="2 d-flex align-items-end">
						<b-button @click="getFeedSupplyList()" variant="primary "> Filter </b-button>
					</b-col>
				</b-row>
			</b-col>
			<!-- Search -->
			<b-col cols="12" md="5" class="mt-2 d-flex justify-content-end align-items-center">
				<div>
					<b-form-input
						type="text"
						class="form-control"
						placeholder="Search"
						@input="getFeedSupplyList()"
						v-model.trim="search_filter.input_field"
						style="border-radius: 4px"
					/>
				</div>
				<b-button
					@click="clearFilter"
					variant="secondary
 			 ml-1"
				>
					Clear
				</b-button>
				<b-button
					v-if="hasPermission('add_supply_to_farm')"
					:to="{
						name: 'apps-supply-farm-feed',
					}"
					variant="primary mr-1 ml-2"
				>
					Add
				</b-button>
				<b-button @click="excelDownload()" variant="warning">
					<feather-icon icon="DownloadIcon" size="16" />
				</b-button>
			</b-col>
		</b-row>
		<div v-if="feedSupplyList && feedSupplyList.total > 0">
			<b-table id="feedSupplyList" :items="feedSupplyList.data" responsive :fields="fields" class="position-relative">
				<template #cell(index)="data">
					<div class="ml-1">
						{{ feedSupplyList.from + data.index }}
					</div>
				</template>
				<template #cell(feed)="data">
					<span v-if="data.item.feed">{{ data.item.feed.name }}</span>
					<span v-else>NA</span>
				</template>
				<template #cell(production_type)="data">
					<span v-if="data.item.production_type">{{ data.item.production_type.name }}</span>
					<span v-else>NA</span>
				</template>
				<template #cell(source)="data">
					<span v-if="data.item.source">{{ data.item.source.name }}</span>
					<span v-else>NA</span>
				</template>
				<template #cell(actions)="data">
					<b-button
						v-if="hasPermission('delete_supply_to_farm')"
						size="sm"
						variant="outline-danger"
						@click="deleteRecord(data.item.id)"
					>
						Delete
					</b-button>
				</template>
			</b-table>
			<div class="mt-2 mb-5">
				<b-pagination
					:value="feedSupplyList.current_page"
					:total-rows="feedSupplyList.total"
					:per-page="feedSupplyList.per_page"
					align="right"
					@change="getFeedSupplyList"
				>
				</b-pagination>
			</div>
		</div>
		<div v-else class="d-flex flex-column align-items-center py-5">
			<b-img :src="require('@/assets/images/svg/infographics/no_data_infographic.svg')" class="mr-2" />
			<h4 class="mt-2 Secondary">Supply Feed List Empty</h4>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";
import { BASE_URL } from "@core/common/constants";
import axiosIns from "@/libs/axios";
import moment from "moment";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
	components: {
		vSelect,
	},
	data() {
		return {
			searchQuery: null,
			page: null,
			fields: [
				{ key: "index", label: "S.no" },
				{
					key: "created_at",
					label: "purchase date",
					formatter: (value) => {
						if (!value) return "—";
						const m = moment(value, ["YYYY-MM-DD", "DD-MM-YYYY", moment.ISO_8601], true);
						return m.isValid() ? m.format("MMMM Do YYYY") : moment(value).format("MMMM Do YYYY");
					},
				},
				{
					key: "feed.name",
					label: "feed name",
				},
				{
					key: "farm.name",
					label: "Farm Name",
				},
				"quantity",
				"batch_no",
				"total_cost",
				{ key: "actions", label: "Actions" },
			],
			search_filter: {
				input_field: "",
				to_date: "",
				from_date: "",
			},
			feedSupplyList: {},
		};
	},
	created: function () {
		this.getFeedSupplyList();
	},
	methods: {
		moment() {
			return moment();
		},

		getFeedSupplyList(pageNo = 1) {
			const farm_id = this.$route.params.farmId;
			let url = `web/feed-supply-farm-list`;
			let queryParams = {
				page: pageNo,
			};

			if (this.search_filter.input_field) {
				queryParams.input_field = this.search_filter.input_field;
			}
			if (this.search_filter.to_date) {
				queryParams.to_date = this.search_filter.to_date;
			}
			if (this.search_filter.from_date) {
				queryParams.from_date = this.search_filter.from_date;
			}

			axiosIns
				.get(this.addQueryString(url, queryParams))
				.then((response) => {
					this.feedSupplyList = response.data.feed_supply_list;
				})
				.catch((error) => {
					this.$toast({
						component: ToastificationContent,
						position: "top-right",
						props: {
							icon: "CoffeeIcon",
							variant: "danger",
							text:
								error.response?.data?.message ||
								error.response?.data?.error ||
								(error.response?.data?.errors
									? Object.values(error.response.data.errors).flat().join(", ")
									: "Something went wrong. Please try again."),
						},
					});
				});
		},

		excelDownload() {
			if (this.search_filter.from_date && this.search_filter.to_date) {
				this.search_filter.from_date = moment(this.search_filter.from_date).format("YYYY-MM-DD");
				this.search_filter.to_date = moment(this.search_filter.to_date).format("YYYY-MM-DD");
			}
			let order_filter_data = this.prepareForm(this.search_filter);
			axiosIns
				.post(`web/export-feed-supply-to-farm`, order_filter_data)
				.then((response) => {
					var tempLink = document.createElement("a");
					tempLink.style.display = "none";
					tempLink.href = response.data.file;
					tempLink.setAttribute("download", response.data.name);
					if (typeof tempLink.download === "undefined") {
						tempLink.setAttribute("target", "_blank");
					}
					document.body.appendChild(tempLink);
					tempLink.click();
					document.body.removeChild(tempLink);
					this.search_filter.to_date = null;
					this.search_filter.from_date = null;
					this.search_filter.input_field == null;
					this.getFeedSupplyList();
				})
				.catch((error) => {
					error.response;
					const data = error.response?.data?.errors;
					data, "data";
					let arr = Object.values(data).flat().toString(",");
					arr, "array";
					this.$toast({
						component: ToastificationContent,
						position: "top-right",
						props: {
							icon: "CoffeeIcon",
							variant: "danger",
							text: arr,
						},
					});
					this.search_filter.to_date = null;
					this.search_filter.from_date = null;
					this.search_filter.input_field == null;
					this.getFeedSupplyList();
				});
		},

		clearFilter() {
			this.search_filter.input_field = "";
			this.search_filter.to_date = "";
			this.search_filter.from_date = "";
			this.getFeedSupplyList();
		},

		deleteRecord(id) {
			this.deleteDataEntry(`web/feed-supply-to-farm/${id}`).then((ok) => {
				if (ok) this.getFeedSupplyList();
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.activeClass {
	background-color: #296db4;
	color: #fff;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
